export default __webpack_public_path__ + "static/media/2021-AMcover.4a5dd65b.png";